<div class="{{ prefixCls }}">
  <div>
    <div class="{{ prefixCls }}-header">
      <a
        class="{{ prefixCls }}-prev-year-btn"
        role="button"
        (click)="previousYear()"
        title="{{ locale.previousYear }}"
      ></a>

      <a
        class="{{ prefixCls }}-year-select"
        role="button"
        (click)="yearPanelShow.emit()"
        title="{{ locale.yearSelect }}"
      >
        <span class="{{ prefixCls }}-year-select-content">{{ value.getYear() }}</span>
        <span class="{{ prefixCls }}-year-select-arrow">x</span>
      </a>

      <a
        class="{{ prefixCls }}-next-year-btn"
        role="button"
        (click)="nextYear()"
        title="{{ locale.nextYear }}"
      ></a>
    </div>
    <div class="{{ prefixCls }}-body">
      <month-table [prefixCls]="'ant-calendar'" [disabledDate]="disabledDate" [value]="value" (valueChange)="valueChange.emit($event)"></month-table>
    </div>
  </div>
</div>